import { DateTime } from "luxon";

export const isAfterTenMinutes = (inputDate: DateTime): boolean => {
  const now = DateTime.now();
  return inputDate >= now.plus({ minutes: 10 });
};
